import React from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import DropDownInputField from "../../components/forms/DropDownInputField";
import FormError from "../../components/forms/FormError";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";

const CreateCustomerForm = (props) => {
  const {handleSubmit, submit, submitting, onCancel} = props;
  const submitLabel = submitting ? "Standby..." : "Submit";

  return (
    <form onSubmit={handleSubmit}>
      <div className="fields">
        <FormFieldsTable>
          <Field
            label="Name"
            name="name"
            component={TextInputField}
            serverError={props.errors.name}
            />
          <Field
            label="Email"
            name="email"
            component={TextInputField}
            serverError={props.errors.email}
            />
          <Field
            label="Phone"
            name="phone"
            component={TextInputField}
            serverError={props.errors.phone}
            />
          <Field
            label="Language"
            name="locale"
            component={DropDownInputField}
            data={props.availableLocales}
            showBlank={false}
            serverError={props.errors.locale}
            />
        </FormFieldsTable>
      </div>
      <FormError error={props.errors._error} />
      <div className="buttons">
        <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
        <ActionButton label="Cancel" active={!submitting} onClick={onCancel} />
      </div>
    </form>
  );
}

const ReduxForm = reduxForm({
  form: "CreateCustomerForm",
})(CreateCustomerForm);

export default ReduxForm;